/* eslint-disable import/prefer-default-export */
import Counting from './Counting';

export default Counting;
